import axios from "axios";
import { message } from "antd";
import { l } from "../../config/language";
import { createInputHtml } from "../../utils/htmlTools";
import UploadFileOss from "../../utils/upload/uploadFile";
import UploadFileS3 from "../../utils/upload/uploadFileS3";
import { get, factory, strFormat, merge } from "../../utils";
import config from "../../config";

/**
 * 返回默认的按钮文本
 *
 * @returns
 */
export const defaultText = function () {
  return {
    back: l("YxAction.bm"),
    jump: l("YxAction.jm"),
    reset: l("YxAction.rm"),
    popup: l("YxAction.pm"),
    submit: l("YxAction.sm"),
    action: l("YxAction.am"),
  };
};

/**
 * 枚举匹配函数
 *
 * @param {object} props 组件props
 * @returns
 */
export const emumMate = function (props, data) {
  const actionType = get(props, "actionType", "action");
  const dict = defaultText();
  const text = get(props, "text");
  const dataIndex = get(props, "dataIndex", null);
  const emumDict = get(props, "emum", {});
  const key = get(data, dataIndex, null);
  const textList = [
    // 根据优先级获得实际的text
    get(emumDict, key, null),
    get(emumDict, text, null),
    text,
    get(emumDict, "defultValue", null),
    dict[actionType],
  ];
  return textList.find((val) => val);
};

/**
 * 返回组件支持的actionType类型
 *
 * @returns
 */
export const typeParam = function () {
  return {
    // 按钮默认参数
    back: {},
    reset: {},
    action: {},
    jump: { type: "primary" },
    popup: { type: "primary" },
    submit: { type: "primary" },
    upload: { type: "primary" },
    downFile: { type: "primary" },
    formAdd: { type: "primary" },
  };
};

/**
 *  返回组件支持的actionType类型 - 具体类型
 *
 * @returns
 */
export const typeList = function () {
  const typeDict = typeParam();
  return Object.keys(typeDict);
};

/**
 * 数据源工厂
 *
 * @param {*} props
 * @returns
 */
export const actionData = function (props) {
  const model = get(props, "model", null);
  const dataFactory = get(props, "factory", null);
  const data = get(props, "data", {});
  return factory(data, model, dataFactory);
};

/**
 * 显示提示语
 *
 */
export const showMessage = function (props) {
  const { actionType } = props;
  const msg = get(props, "message", null);
  const dict = {
    action: get(props, "message", l("YxAction.asm")),
    submit: get(props, "message", l("YxAction.ssm")),
    upload: get(props, "message", l("YxAction.usm")),
    downFile: get(props, "message", l("YxAction.dsm")),
  };
  if (msg !== false && Object.keys(dict).includes(actionType)) {
    console.log("提示语如果要关闭，给message设置为false");
    message.success(dict[actionType]);
  }
};

/**
 * 控制路由跳转
 *
 * @param {Object} props
 * @param {Object} route 路由对象
 * @param {Object} data 组件数据源
 * @param {Object} res 接口返回数据
 */
export const routeGoto = function (props, route, data, res) {
  const actionType = get(props, "actionType", "action");
  const path = get(props, "path", null);
  if (["jump", "back"].includes(actionType)) {
    return;
  } else {
    let address = null;
    if (path instanceof Function) {
      address = path({ data, res });
    } else if (typeof path === "string") {
      const mergeData = merge(res, data);
      address = strFormat(path, mergeData);
    }
    address && route.push(address);
  }
};

/**
 * 超时强制关闭这个promise
 *
 * @param {*} reject
 * @param {*} dom
 */
const mandatoryCloseUpload = function (reject, dom) {
  const closeLoading = function () {
    dom && dom.remove();
    reject("promise超时");
  };
  setTimeout(closeLoading, 3 * 60 * 1000);
  return closeLoading;
};

/**
 * 上传oss执行逻辑
 *
 * @param {*} promiseAction 请求上传接口
 * @param {object} extra 扩展参数
 * @param {*} loading 调用开启loading函数
 * @returns
 */
const uploadComBind = function (promiseAction, loading, extra = {}) {
  return new Promise((resolve, reject) => {
    const dom = createInputHtml(async (files, dom) => {
      const closeLoading = mandatoryCloseUpload(reject, dom);
      loading();
      const promiseList = [];
      for (let file of [...files]) {
        promiseList.push(promiseAction(file));
      }
      let result = await axios.all(promiseList);
      dom.parentElement.removeChild(dom);
      clearTimeout(closeLoading);
      resolve(result);
    }, extra);
    dom.click();
  });
};

/**
 * 创建上传实例
 *
 * @param {*} props
 * @returns
 */
export const createUpload = async function (props) {
  const actionType = get(props, "actionType", "action");
  if (actionType === "upload") {
    const param = get(props, "uploadConfig", {});
    const uploadType = get(param, "uploadType", "oss");
    if (uploadType === "s3") {
      return await UploadFileS3.new(param);
    }
    return new UploadFileOss(param);
  }
  return null;
};

/**
 * 上传文件
 *
 * @param {*} param
 * @param {*} upload
 * @param {*} loading
 * @returns
 */
export const uploadFileAction = async function (param, upload, loading) {
  const uploadType = get(param, "uploadType", "oss");
  let fileUrl = null;
  if (uploadType === "oss") {
    const uploadFileOss = upload;
    fileUrl = await uploadComBind(
      uploadFileOss.uploadFileAction,
      loading,
      param
    );
  } else {
    const uploadObj = upload;
    fileUrl = await uploadComBind(uploadObj.uploadFile, loading, param);
  }
  return fileUrl;
};

/**
 * 判断一组数组的某个字段是否全部相等
 *
 * @param {Array} list
 * @param {string} field
 * @returns
 */
export const unifiedFields = function (list, field, defultValue) {
  let result = get(list, `[0][${field}]`, defultValue);
  for (let item of list) {
    if (get(item, field, defultValue) !== result) {
      return defultValue;
    }
  }
  return result;
};

export const parseQueryString = (url) => {
  let obj = {},
    keyvalue = [],
    key = "",
    value = "";
  const paraString = url.split("?");
  obj[get(config, "embeddedRender.pathName")] = paraString[0];
  const urlParam = paraString[1] && paraString[1].split("&");
  for (let i in urlParam) {
    keyvalue = urlParam[i].split("=");
    key = keyvalue[0];
    value = keyvalue[1];
    obj[key] = value;
  }
  return obj;
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/tools.js